import { createAction } from '@reduxjs/toolkit';

import type {
  CreateEntityPayload,
  DeleteEntityPayload,
  UpdateEntityPayload,
} from '@polyai/stream/commands/handlers/entities';

const PREFIX = 'entities';

const createEntity = createAction<CreateEntityPayload>(
  `${PREFIX}/createEntity`,
);

const updateEntity = createAction<UpdateEntityPayload>(
  `${PREFIX}/updateEntity`,
);

const deleteEntity = createAction<DeleteEntityPayload>(
  `${PREFIX}/deleteEntity`,
);

export { createEntity, deleteEntity, updateEntity };
